export enum LeadType {
    CUSTOMER = "CUSTOMER",
    CUSTOMER_PARTNER = "CUSTOMER_PARTNER",
}

export enum LeadStatus {
    NEW = "NEW",
    CONTACTED = "CONTACTED",
    QUALIFIED = "QUALIFIED",
    IN_FLOW = "IN_FLOW",
    DEAL_CREATED = "DEAL_CREATED",
    CONVERTED = "CONVERTED",
    LOST = "LOST",
    INVALID_DETAILS = "INVALID_DETAILS",
    NEEDS_CONTACT = "NEEDS_CONTACT",
}

export enum LeadSource {
    PHONE = "PHONE",
    WEBSITE = "WEBSITE",
    WHATSAPP = "WHATSAPP",
    REFERRAL = "REFERRAL",
    WEBINAR = "WEBINAR",
    MANUAL = "MANUAL"
}

export enum LeadPreConsultationStatus {
    NOT_SENT = "NOT_SENT",
    SENT = "SENT",
    RECEIVED = "RECEIVED",
    FAILED = "FAILED",
}

export enum IntentType {
    ONE_TIME_CONSULTATION = "ONE_TIME_CONSULTATION",
    COUPLE_CONSULTATION = "COUPLE_CONSULTATION",
    ONGOING = "ONGOING",
    UNKNOWN = "UNKNOWN"
}

export class Lead {
    id: number;
    company_id?: number;
    created_at?: string;
    updated_at?: string;

    first_name: string;
    last_name: string;
    phone?: string;
    email?: string;

    lead_type?: LeadType;
    lead_source?: LeadSource;
    campaign_id?: number;

    status: LeadStatus;
    intent_type?: IntentType;

    assigned_agent_id?: number;
    notes?: string;
    last_activity_date?: string;

    partner_lead_id?: number;
    external_partner_crm_id?: string;

    israeli_id?: string;
    id_issue_date?: string;
    birth_date?: string;
    marital_status?: string;

    street?: string;
    house_number?: string;
    city?: string;

    workplace?: string;
    occupation?: string;

    lead_signed_at?: string;
    signed_ip?: string;

    pre_consultation_status?: LeadPreConsultationStatus;
    pre_consultation_sent_at?: string;
    pre_consultation_received_at?: string;
    external_pre_consultation_id?: string;

    external_crm_id?: string;
    external_crm_created_at?: string;
    external_crm_updated_at?: string;

    draft_party_id?: number;
    converted_contact_id?: number;
    deal_id?: number;

    constructor(init?: Partial<Lead>) {
        Object.assign(this, init);
    }

    static defaultEmpty(): Partial<Lead> {
        return {
            first_name: "",
            last_name: "",
            status: LeadStatus.NEW,
        };
    }
}
